import { Link } from "react-router-dom"

export default function Footer() {
  return (
    <footer className="bg-[#181818] text-white h-[377px]">
      <div className="container container-max-w mx-auto px-4 pt-[72px]">
        <div className="flex flex-col md:flex-row justify-between items-start mb-[32px]">
          <div className="mb-8 md:mb-0 bg-[url(../assets/images/idata-logo.gif)] bg-contain w-[288px] h-[90px]"></div>
        </div>
        <div className="border-t border-[#999] pt-[24px] flex justify-between">
          <div>
            <div className="flex space-x-6 mb-[52px]">
              <Link to="/about" className="hover:underline text-[#fff] text-[16px] font-bold">
                About iData
              </Link>
              <Link to="/privacy-policy" className="hover:underline text-[#fff] text-[16px] font-bold">
                Privacy Policy
              </Link>
              <Link to="/term-of-use" className="hover:underline text-[#fff] text-[16px] font-bold">
                Term of Use
              </Link>
            </div>
            <div className="text-[12px] text-gray-400">
              <span>iData Tech, Inc.</span>
              <span className="ml-[20px]">Zhejiang IPC No.18026790</span>
            </div>
          </div>
          <div>
            <div className="flex mb-[15px]">
              <div className="text-[12px] text-[#A4A4A4] w-[50px] mr-[40px]">Email:</div>
              <div className="text-[12px] text-[#ffffff]">contacts@idatausa.com</div>
            </div>
            <div className="flex mb-[15px]">
              <div className="text-[12px] text-[#A4A4A4] w-[50px] mr-[40px]">Tel:</div>
              <div className="text-[12px] text-[#ffffff]">(+1) 302-386-8402</div>
            </div>
            <div className="flex">
              <div className="text-[12px] text-[#A4A4A4] w-[50px] mr-[40px]">Address: </div>
              <div className="text-[12px] text-[#ffffff]">418 Broadway, #5095, Albany, NY 12207</div>
            </div>
          </div>
        </div>
      </div>
    </footer>
  )
}
